import styled from 'styled-components';
import { media } from '@pik/pik-ui';

export default styled.article`
  font-family: Graphik;
  color: #222222;
  letter-spacing: 0;
  font-size: ${({ fontSize }) => (fontSize || '24px')};
  line-height: ${({ lineHeight }) => (lineHeight || '32px')};
  white-space: ${({ isHtmlData }) => (isHtmlData ? 'normal' : 'pre-wrap')};
  
  ${({ margin }) => !!margin && `margin: ${margin};`}
  ${({ noWrap }) => !!noWrap && 'white-space: normal;'}
  ${({ width }) => !!width && `max-width: ${width}px;`}
  
  li {
    list-style-type: disc;
    margin-left: 10px;
    margin-bottom: 20px;
  
    ul {
      margin-top: 20px;
      margin-left: 30px;
    }
  }
  
  ul {
    margin-bottom: 8px;
  }

  p {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      margin-bottom: 0 !important;
    }
  }
  
  em {
    font-style: italic;
  }

  b, strong {
    font-weight: 500;
  }
  
  img {
    max-width: 100%;
    margin-bottom: 20px;
  }

  a {
    color: #5a7788;
    text-decoration: underline;
    
    &:hover {
      color: #456577;
      text-decoration: none;
    }
  }
  
  @media ${media.max768} {
    font-size: ${({ fontSize }) => (fontSize || '20px')};
    line-height: ${({ lineHeight }) => (lineHeight || '28px')};
    
  p {
    margin-bottom: 12px;
  }
`;
